import ReactCountryFlag from "react-country-flag";
import clsx from "clsx";
import { memo, useMemo } from "react";

import classes from "./styles.module.scss";

import type { IFlagProps } from "@components/atoms/flag/types";

export const Flag = memo(function Flag({ flag }: IFlagProps) {
  return useMemo(
    () => (
      <ReactCountryFlag
        countryCode={flag}
        svg
        className={clsx(classes.flag)}
        style={{ width: "1.25rem", height: "1.25rem" }}
        cdnUrl={"https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.3.2/flags/1x1/"}
        cdnSuffix={"svg"}
        title={flag}
      />
    ),
    [flag],
  );
});
